(function () {
  const ROOT_SELECTOR = '.ms-judgeme-reviews';

  function isFormVisible(formWrapper) {
    if (!formWrapper) return false;
    const style = window.getComputedStyle(formWrapper);
    return style.display !== 'none' && formWrapper.offsetHeight > 0;
  }

  function ensureCloseButton(form) {
    if (!form || form.querySelector('.ms-jdgm-modal-close')) return;

    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'ms-jdgm-modal-close';
    button.setAttribute('aria-label', 'Close review form');
    button.textContent = '\u00d7';
    form.insertBefore(button, form.firstChild);
  }

  function init(root) {
    if (!root || root.dataset.jdgmModalInit === 'true') return;

    const formWrapper = root.querySelector('.jdgm-form-wrapper');
    if (!formWrapper) return;

    root.dataset.jdgmModalInit = 'true';

    const form = formWrapper.querySelector('.jdgm-form');
    ensureCloseButton(form);

    const cancelLink = formWrapper.querySelector('.jdgm-cancel-rev');

    const openModal = () => {
      root.classList.add('ms-jdgm-form-open');
      document.body.classList.add('ms-jdgm-form-open');
    };

    const closeModal = () => {
      root.classList.remove('ms-jdgm-form-open');
      document.body.classList.remove('ms-jdgm-form-open');
    };

    const syncModal = () => {
      if (isFormVisible(formWrapper)) openModal();
      else closeModal();
    };

    root.addEventListener(
      'click',
      (event) => {
        if (event.target.closest('.jdgm-write-rev-link')) {
          window.setTimeout(openModal, 0);
        }
      },
      true
    );

    const observer = new MutationObserver(syncModal);
    observer.observe(formWrapper, {
      attributes: true,
      attributeFilter: ['style', 'class'],
    });

    root.addEventListener('click', (event) => {
      if (event.target === formWrapper) cancelLink?.click();
    });

    formWrapper.addEventListener('click', (event) => {
      const closeButton = event.target.closest('.ms-jdgm-modal-close');
      if (closeButton) {
        event.preventDefault();
        cancelLink?.click();
      }
    });

    cancelLink?.addEventListener('click', () => {
      closeModal();
      window.setTimeout(syncModal, 0);
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && root.classList.contains('ms-jdgm-form-open')) {
        cancelLink?.click();
      }
    });

    syncModal();
  }

  function boot() {
    document.querySelectorAll(ROOT_SELECTOR).forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  new MutationObserver(boot).observe(document.body, {
    childList: true,
    subtree: true,
  });
})();
